import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { DateTime } from "luxon"
import { Badge, Tooltip } from "@oysterhr/ui"
import { CreditNote, CreditNoteState } from "@oysterhr/schema"
import { CreditNoteStateLabelsMap } from "../../constants/creditNotes"

interface Props {
  creditNote: Pick<CreditNote, "state" | "refundStartedAt">
}

export const CreditNoteStatusPill = ({ creditNote }: Props) => {
  const { t } = useTranslation("CreditNotes")
  const { state, refundStartedAt } = creditNote
  const { variation, translationKey, tooltipKey } = CreditNoteStateLabelsMap[state]
  const tooltip = useMemo(() => {
    if (!tooltipKey) return undefined

    if (state === CreditNoteState.Refunded) {
      return t(tooltipKey, {
        date: DateTime.fromISO(refundStartedAt).toLocaleString(DateTime.DATE_MED),
      })
    }
  }, [refundStartedAt, state, t, tooltipKey])

  const pill = <Badge variation={variation}>{t(translationKey)}</Badge>

  if (tooltip) {
    return (
      <Tooltip value={tooltip}>
        <div>{pill}</div>
      </Tooltip>
    )
  }
  return pill
}
